import { Typography } from '@material-ui/core'
import useStyles from './styles'
import { InvalidPartsOrderCopyProps } from './types'

export const InsuranceLimitReachedCopy = (
  _props: InvalidPartsOrderCopyProps
) => {
  const classes = useStyles()
  return (
    <>
      <Typography
        className={classes.title}
        color="primary"
        component="h1"
        variant="h4"
      >
        You've used your entire insurance benefit for replacement parts.
      </Typography>
      <Typography className={classes.body} color="primary" variant="body2">
        The maximum number of replacement parts orders has been reached.
      </Typography>
    </>
  )
}
